import { Box, styled } from '@mui/material';

export const ViewFamilyMemberDrawerStyled = styled(Box)({
  '& .drawer-dialog': {
    textAlign: 'left',
  },
});
